// App.js — with persistent SideMenu (left) and NavBar (top) for all signed-in views

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomeView from './views/HomeView';
import SignupView from './views/SignupView';
import VerificationEmailSentView from './views/VerificationEmailSentView';
import EmailVerifiedView from './views/EmailVerifiedView';
import EmailVerificationInvalidView from './views/EmailVerificationInvalidView';

import SubscriptionPlansView from './views/SubscriptionPlansView';
import PaymentView from './views/PaymentView';
import PaymentSuccessView from './views/PaymentSuccessView';
import PaymentErrorView from './views/PaymentErrorView';
import UserProfileView from './views/UserProfileView';
import ProfileView from './views/ProfileView';
import RequestPasswordResetView from './views/RequestPasswordResetView';
import PasswordResetView from './views/PasswordResetView';
import LifetimeDealCalculatorView from './views/LTDCalculatorView';
import LoginView from './views/LoginView';
import AnalysisView from './views/AnalysisView';
import FeedbackFormView from './views/FeedbackFormView';
import SitesView from './views/SitesView';
import SiteView from './views/SiteView';
import SiteDashboardView from './views/SiteDashboardView';
import SitePageView from './views/SitePageView';
import ChatView from './views/ChatView';
import HelpView from './views/HelpView';
import OnboardingView from './views/OnboardingView';
import SuperadminView from './views/SuperadminView';

import SideMenu from './components/SideMenu';
import NavBar from './components/NavBar';
import { AuthProvider, useAuth } from './AuthContext';

import './App.css';

function AuthenticatedLayout() {
	const { token } = useAuth();

	if(!token) {
		return <LoginView />;
	}

	// <Route path="/payment" element={<PaymentView />} />
	// <Route path="/payment_success" element={<PaymentSuccessView />} />
	// <Route path="/payment_error" element={<PaymentErrorView />} />
	// <Route path="/plans" element={<SubscriptionPlansView />} />
	// <Route path="/profile" element={<UserProfileView />} />

	return (
		<div className="App">
			<SideMenu />
			<div className="main-content">
				<NavBar />
				<Routes>
					<Route path="/" element={<AnalysisView />} />
					<Route path="/aeo_analysis" element={<AnalysisView enable_analysis_form={true}/>} />
					<Route path="/feedbackform" element={<FeedbackFormView />} />
					<Route path="/sites" element={<SitesView />} />
					<Route path="/site/:id" element={<SiteView />} />
					<Route path="/site/:id/analysis/:site_analysis_id" element={<SiteView />} />
					<Route path="/site/:id/dashboard" element={<SiteDashboardView />} />
					<Route path="/site-page/:id" element={<SitePageView />} />
					<Route path="/profile" element={<ProfileView />} />
					<Route path="/chat" element={<ChatView />} />
					<Route path="/help" element={<Navigate to="/help/introduction" replace />} />
					<Route path="/help/:key" element={<HelpView />} />
					<Route path="/onboarding" element={<OnboardingView />} />
					<Route path="/superadmin" element={<Navigate to="/superadmin/subscriptions" replace />} />
					<Route path="/superadmin/:tab" element={<SuperadminView />} />
					<Route path="/superadmin/users/:user_id" element={<SuperadminView />} />
				</Routes>
			</div>
		</div>
	);
}

function App() {

	// <Route path="/*" element={<AuthenticatedLayout />} />

	return (
		<AuthProvider>
			<BrowserRouter>
				<Routes>
					<Route path="/login" element={<LoginView />} />
					<Route path="/plans" element={<SubscriptionPlansView />} />
					<Route path="/signup" element={<SignupView />} />
					<Route path="/verification_email_sent" element={<VerificationEmailSentView />} />
					<Route path="/email_verified" element={<EmailVerifiedView />} />
					
					<Route path="/email_link_invalid" element={<EmailVerificationInvalidView />} />
					<Route path="/request_password_reset" element={<RequestPasswordResetView />} />
					<Route path="/password_reset/:token" element={<PasswordResetView />} />
					<Route path="/*" element={<AuthenticatedLayout />} />

				</Routes>
			</BrowserRouter>
		</AuthProvider>
	);
}

export default App;
